import React, { useEffect, useState } from "react";
import AppLayout from "../components/layout/AppLayout";
import api from "../api/api";
import CourseCard from "../components/dashboard/CourseCard";
import Spinner from "../components/common/Spinner";

function CompletedPage() {
  const [completed, setCompleted] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/courses").then((res) => {
      const done = (res.data.courses || []).filter((c) => c.progress === 100);
      setCompleted(done);
      setLoading(false);
    });
  }, []);

  if (loading)
    return (
      <AppLayout>
        <Spinner />
      </AppLayout>
    );

  return (
    <AppLayout>
      <div className="p-8">
        <h1 className="text-3xl font-extrabold mb-6">🏁 Cursos Concluídos</h1>

        {completed.length === 0 && (
          <p className="text-gray-500">Nenhum curso concluído ainda.</p>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {completed.map((c) => (
            <CourseCard key={c.id} course={c} />
          ))}
        </div>
      </div>
    </AppLayout>
  );
}

export default CompletedPage;
